export const ATTENDED = 'attended'
export const ATTENDING = 'attending'
export const CONFIRMED = 'confirmed'
export const NO_SHOW = 'no_show'
export const NOT_ATTENDING = 'not_attending'
export const WAITING_LIST = 'waiting_list'
